<!-- eslint-disable vue/valid-v-bind -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
  <v-container class="pa-0">
    <v-container class="wrapper-vmenu pa-0">
      <v-menu
        attach=".wrapper-vmenu"
        :close-on-content-click="false"
        v-model="profileMenu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-container
            class="wrapper-user-data d-flex justify-space-between align-center gap-2"
            v-bind="attrs"
            v-on="on"
          >
            <div class="d-flex align-center">
              <v-icon size="15">mdi-chevron-down</v-icon>
            </div>
            <div class="d-flex align-center gap-2">
              <v-card-text
                class="text-caption pa-0"
                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
              >
                {{ $store.state.fullname }}
              </v-card-text>
              <img
                :src="
                  userInfo?.init?.user?.avatar?.link || require('@/assets/Avatar.png')
                "
              />
            </div>
          </v-container>
        </template>
        <v-card class="wrapper-menu ma-0">
          <v-container class="d-flex justify-space-between align-center pa-0">
            <div class="d-flex align-center">
              <!--<v-icon>mdi-chevron-right</v-icon>-->
            </div>
            <div class="d-flex align-center gap-2">
              <div>
                <v-card-text class="text-caption pa-0">{{
                  $store.state.fullname
                }}</v-card-text>
                <!--<v-card-text class="text-body-2 pa-0" dir="ltr" style="color: #a3a2a2;">developer</v-card-text>-->
              </div>
              <img
                :src="
                  userInfo?.init?.user?.avatar?.link || require('@/assets/Avatar.png')
                "
              />
            </div>
          </v-container>
          <v-divider class="mt-2" />
          <v-container class="d-flex justify-space-between pa-0 my-3">
            <span class="text-caption" style="color: #a3a2a2">{{
              $t("account-id")
            }}</span>
            <span class="text-caption">{{
              serviceInfo && serviceInfo.appKey ? serviceInfo.appKey : "-"
            }}</span>
          </v-container>
          <!-- <v-container class="d-flex justify-space-between pa-0 my-3">
                        <span class="text-caption" style="color: #a3a2a2;">{{ $t('sms-count') }}</span>
                        <span class="text-caption">{{ (serviceInfo && serviceInfo.smsCountRemain) ? serviceInfo.smsCountRemain : '-' }}</span>
                    </v-container>
                    <v-container class="d-flex justify-space-between pa-0 my-3">
                        <span class="text-caption" style="color: #a3a2a2;">{{ $t('supportExpireDate') }}</span>
                        <span class="text-caption">{{ (serviceInfo && serviceInfo.expireDate) ? serviceInfo.expireDate : '-' }}</span>
                    </v-container> -->
          <v-divider class="mb-2" />
          <v-card-text
            class="role-button text-caption py-2 px-1"
            style="cursor: pointer"
            @click="openProfile"
          >
            {{ $t("account-setting") }}
          </v-card-text>
          <v-progress-circular
            v-if="loadingLogOut"
            indeterminate
            size="20"
            width="3"
            color="secondary"
          />
          <v-card-text
            v-else
            class="role-button text-caption py-2 px-1"
            style="cursor: pointer"
            @click="logout"
          >
            {{ $t("exit-account") }}
          </v-card-text>
        </v-card>
      </v-menu>
    </v-container>
    <!--dialog--><!--old-->
    <v-dialog
      v-model="profileDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="600"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            color="grey darken-2"
            class="close-hover"
            @click="profileDialog = false"
          >
            <v-icon large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <profile ref="profileRef" />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6" />
            <v-col cols="6">
              <v-btn
                color="pink"
                outlined
                class="float-left"
                @click="profileDialog = false"
              >
                {{ $t("close") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Profile from "@/views/dashboard/pages/General/profile.vue";

export default {
  name: "DashboardCoreAppBar",
  data() {
    return {
      profileMenu: false,
      serviceInfo: null,
      profileDialog: false,
      userInfo: null,
      loading: false,
      loadingLogOut: false,
    };
  },
  components: {
    Profile,
  },
  methods: {
    getServiceInfo() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "getServiceInfo",
            search: null,
            page: 1,
          },
        })
        .then((r) => {
          this.serviceInfo = r.data;
          this.$store.commit("SET_SMSCOUNTREMAIN", r.data.smsCountRemain);
          this.$store.commit("SET_EXPIREDATE", r.data.expireDate);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openProfile() {
      var app = this;
      this.profileDialog = true;
      setTimeout(function () {
        app.$refs.profileRef.getProfile();
      }, 0);
    },
    // logout () {
    //   var app = this
    //   app.loadingLogOut = true
    //   this.$axios
    //     .post(this.$apipoint + 'v2/logout')
    //     .then((response) => {
    //       const keep = ['scaleConfig', 'selectedPrinter', 'posDevice']

    //       Object.keys(localStorage).forEach(key => {
    //         if (!keep.includes(key)) {
    //           localStorage.removeItem(key)
    //         }
    //       })

    //       this.$router.push({ name: 'logout' })
    //       delete this.$axios.defaults.headers.common.domain
    //     })
    //     .catch((err) => {
    //       app.serverErrorHandeler(err)
    //       app.loadingLogOut = false
    //     })
    //     .finally(() => {
    //       app.loadingLogOut = false
    //     })
    // }
    logout() {
      const app = this;
      app.loadingLogOut = true;

      const clearAndRedirect = () => {
        const keep = ["scaleConfig", "selectedPrinter", "posDevice"];
        Object.keys(localStorage).forEach((key) => {
          if (!keep.includes(key)) localStorage.removeItem(key);
        });
        delete app.$axios.defaults.headers.common.Authorization;
        delete app.$axios.defaults.headers.common.domain;
        app.$router.push({ name: "logout" });
      };

      this.$axios
        .post(this.$apipoint + "v2/logout")
        .catch(() => {
        })
        .finally(() => {
          clearAndRedirect();
          app.loadingLogOut = false;
        });
    },
  },
  watch: {
    profileMenu(val) {
      this.getServiceInfo();
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("token"));
    this.getServiceInfo();
  },
};
</script>

<style scoped>
.wrapper-app-bar .v-toolbar__content .wrapper-user-data {
  border: 1px solid silver;
  width: auto;
  height: 38px;
  border-radius: 4px;
  padding: 4px !important;
  cursor: pointer;
}
.wrapper-app-bar .v-toolbar__content .wrapper-user-data img,
.wrapper-menu img {
  width: 30px;
  height: 30px;
  border-radius: 3px;
}
.wrapper-menu {
  padding: 8px;
  height: auto;
  overflow-y: clip;
  line-height: unset;
  width: 220px;
}
.wrapper-menu .role-button:hover {
  background-color: #fcfcfc;
}
/deep/ .wrapper-vmenu .v-menu__content {
  width: 190px;
  min-width: unset !important;
  max-width: unset !important;
  left: 0 !important;
  top: 38px !important;
}
</style>
